import { defaultIconColor } from './constants';
import { SVGComponentPropsType } from './types';

const defaultSize = 24;

export default ({ color = defaultIconColor, size = defaultSize, ...props }: SVGComponentPropsType) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={size}
    height={size}
    viewBox={`0 0 ${defaultSize} ${defaultSize}`}
    {...props}
  >
    <path
      d="M13.328 22.112v-2.543c1.563-.172 2.758-.625 3.586-1.36.828-.734 1.242-1.668 1.242-2.8 0-.915-.285-1.688-.855-2.32-.57-.634-1.598-1.235-3.082-1.806l-.89-.34V6.679c1.21.094 2.429.383 3.655.867l.856-2.144a12.912 12.912 0 0 0-4.512-.961V2.506H11.77v1.969c-1.438.148-2.577.57-3.416 1.265-.84.696-1.26 1.583-1.26 2.66 0 1.008.295 1.854.885 2.538.59.683 1.525 1.271 2.806 1.763l.985.364v4.383c-.711-.008-1.516-.124-2.415-.346-.898-.223-1.683-.498-2.355-.826v2.472c1.242.563 2.832.86 4.77.89v2.474h1.558zM11.77 10.369c-.727-.289-1.229-.582-1.506-.879-.278-.296-.416-.667-.416-1.113 0-.43.164-.789.492-1.078.328-.289.805-.48 1.43-.574v3.644zm1.558 6.985v-3.739c.742.274 1.272.557 1.588.85.316.293.475.666.475 1.12 0 .968-.688 1.558-2.063 1.769z"
      fill={color}
      fillRule="nonzero"
    />
  </svg>
);
